export default {
  leoChat: {
    chat_1475da: "エンタープライズログイン",
    chat_16f606: "整数。単位はデバイス/契約に依存",
    chat_17dfdc: "マイ設定",
    chat_22f4eb: "使用量と課金",
    chat_27e8b6: "タグ（記憶設定から）",
    chat_29f404: "ブレンダーレシピ",
    chat_30_can_4ab820: "過去30日間の CAN デコードフレーム",
    chat_30_can_8fe750: "過去30日間の CAN 計量合計",
    chat_30_e47539: "過去30日間の入金済み引き落とし",
    chat_30_token_16fa23: "過去30日間の Token",
    chat_33613d: "チャット",
    chat_40d6e4: "ゲストとして続行（製品と公開問い合わせ）",
    chat_43631f: "リスニング停止",
    chat_4845c6: "処理中…",
    chat_553891: "記入してデバイスに合わせる",
    chat_5cd727: "チャットに戻る",
    chat_62e9d1: "モード選択",
    chat_6888c5: "保存",
    chat_6adada: "コンソール",
    chat_6d1197: "利用規約とプライバシーポリシー",
    chat_7106a7: "機台商品",
    chat_71c576: "パスワードを入力してください",
    chat_755be2: "出品登録",
    chat_7847b8: "送信",
    chat_7e76c4: "課金アカウントがまだ作成されていません。保存後、選択したモードで計量が開始されます。",
    chat_805f8b: "このコンテンツを使用",
    chat_85406a: "読み上げをスキップ",
    chat_965a50: "店舗管理者",
    chat_9b2c38: "メッセージを入力",
    chat_9cbbd1: "最後の認識",
    chat_a84cf9: "空欄＝グローバル設定。指定するとそのデバイス専用",
    chat_ab185d: "入力欄に記入",
    chat_abd535: "メンバー登録",
    chat_api_a76f41: "（サブスクリプションプランは運用または API で作成してください）",
    chat_app_c884f6: "他のアプリがリンクまたはキーをコピーしている場合は、直接貼り付けてください。",
    chat_b347b6: "現在の課金設定",
    chat_b6d41c: "コマンドをコピー",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例：curve_soft",
    chat_d2de5e: "登録完了。メンバーとして再ログインして続行してください。",
    chat_d5e285: "を読み、同意しました",
    chat_d5edfc: "全文をコピー",
    chat_da4d71: "メンバーログイン",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "バックエンド完全ログインページ",
    chat_e6a549: "閉じる",
    chat_ea544c: "アカウントを入力してください",
    chat_ef5cb: "リロード",
    chat_email_leo_fda298: "メール + パスワード。ログイン後、Leo チャットに戻り、手順に従ってアクティベーションを完了してください。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "設定を保存",
    chat_fe497b: "メンバーアカウントでログインしてください。店舗管理者は「エンタープライズバックエンド」タブを使用してください。ログイン後、プロンプトに従って家庭用または商用設定を完了してください。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "カメラ権限が必要。HTTPS または localhost を推奨。デバイスまたは製品の QR/バーコードに合わせてください。",
    chat_leo_323396: "Leo 使用量と課金",
    chat_leo_99743: "Leo ガイド",
    chat_leo_ac1503: "メンバーログインして Leo に入る",
    chat_leo_e3ca11: "Leo アクティベーション手順",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "エンタープライズログインして Leo に入る",
    chat_loaderror_108d9d: "ロードエラー",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例：night_owl",
    chat_png_d92bec: "PNG をダウンロード",
    chat_qr_25f92d: "スキャンと製品 QR",
    chat_qr_40dfbd: "QR を生成",
    chat_qr_a9ae66: "アルバムのスクリーンショットまたは写真を選択し、オフラインで QR/バーコードを認識します。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "店舗のレシピキーワード、URL、または SKU を QR に変換し、PNG をダウンロードしてラベルを印刷できます。",
    chat_token_7959d6: "累計 Token（全期間）",
    chat_token_can_dbc_28957f: "Token と車載 CAN/DBC 使用量、ウォレット/台帳の引き落とし記録を表示（メンバーとしてログインするか、バックエンドアカウントが商用バインディング済みであること）。",
    chat_user_ace2e8: "バックエンド User アカウント。メニュー権限を持つユーザーはデバイスとデータセンターを操作できます。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "この言語で Leo NL を有効にしますか？",
      later: "稍后",
      no: "いいえ",
      subProgress: "生成中…",
      subPrompt: "%1$s の音声コマンドを AI で理解",
      titleProgress: "Leo NL 言語理解を準備中…",
      titlePrompt: "この言語で Leo NL を有効にしますか？",
      titleReady: "Leo NL 言語パックの準備完了",
      yes: "はい",
  },
  route: {
    homePage: 'ホーム',
    dataDisplay: 'データ表示',
    atlas: '地図',
    journal: 'ログ',
    details: '詳細',
    systemSetting: 'システム設定',
    loginAccount: '管理用垢',
    merchants: '加盟店管理',
    devices: "機器管理",
    material: "原料管理",
    deviceConfig: "機器設定",
    channelConfiguration: "レーン設定",
    configProfileLibrary: "プロファイル一覧",
    coffeeMachineChannelSlots: "X600H配方センター",
    configBindDispatch: "紐付けと配信",
    leoKnowledgeGroup: 'Leo ナレッジ',
    leoKnowledgeModelFields: '型番ナレッジ項目',
    leoKnowledgeEquipmentTypeTypeKey: '機器種別 type_key',
    leoKnowledgeUpload: 'ナレッジアップロード',
    leoKnowledgeIngestBatch: '取込バッチ（自動）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT パイプライン',
    leoKnowledgeCapabilityMatrix: '能力マトリクス',
    leoKnowledgeOnboarding: 'スマート型番オンボーディング',
    leoKnowledgeTesterConsole: 'テスター・コンソール',
    leoKnowledgePipelineHub: 'パイプライン一覧',
    leoKnowledgeFeatureSurface: '機能→API マッピング',
    leoKnowledgeProtocolDoc: 'プロトコル文書索引',
    leoKnowledgeRemoteTools: '遠隔ツール一覧',
    leoKnowledgeLearning: '学習ループ',
    leoKnowledgeExternalIngest: '外部ナレッジ取込',
    leoKnowledgePortalHub: 'Leo チャット／運用',
    leoKnowledgePortalHubDesc: 'Leo チャット（主入口）と Biz 運用。Console／Portal は内部運維のみ。',
    leoKnowledgePortalHubHint: 'コンソールはバブル型 UI。portalToken／ceoBearer が必要な場合は開いた後に URL へ付与してください。',
    leoKnowledgeUiSurfaceSample: '管理画面ビジュアルサンプル（グレー地）',
    uiSurfaceSampleLead: 'ページ全体を浅いグレーにし、KPI・絞り込み・表を白カードに載せる例です。長時間の全白画面より目が疲れにくい構成の参考にしてください。',
    uiSurfaceSampleAlert: '見た目のサンプルです。フォームと表はダミーデータで、バックエンドは呼び出しません。',
    uiSurfaceSampleKpi_orders: '本日注文（ダミー）',
    uiSurfaceSampleKpi_online: 'オンライン端末',
    uiSurfaceSampleKpi_alerts: '未処理アラート',
    uiSurfaceSampleKpiSub: 'サンプル数値',
    uiSurfaceSampleFilterTitle: '絞り込み（白カード）',
    uiSurfaceSampleKeyword: 'キーワード',
    uiSurfaceSampleKeywordPh: '名称またはコード',
    uiSurfaceSampleStatus: '状態',
    uiSurfaceSampleStAll: 'すべて',
    uiSurfaceSampleStOn: '有効',
    uiSurfaceSampleStOff: '無効',
    uiSurfaceSampleReset: 'リセット',
    uiSurfaceSampleSelectPh: '選択してください',
    uiSurfaceSampleTableTitle: '一覧イメージ（白カード＋表）',
    uiSurfaceSampleColName: '名称',
    uiSurfaceSampleColRegion: '地域',
    uiSurfaceSampleColStatus: '状態',
    uiSurfaceSampleColUpdated: '更新日時',
    uiSurfaceSampleCompareTitle: '対比：全面白 vs レイヤー型グレー',
    uiSurfaceSampleCompareOld: '旧：広い純白',
    uiSurfaceSampleCompareOldDesc: '背景と内容が同じ白だと境界が弱く、長時間の閲読で負担が増えがちです。',
    uiSurfaceSampleCompareNew: '提案：グレー上の白カード',
    uiSurfaceSampleCompareNewDesc: '本文は白でコントラストを確保し、ページ全体は浅いグレーで視線の置き場を作ります。',
    leoPortalHubSovereign: 'コンソール（全画面）',
    leoPortalHubPortal: 'ポータル',
    leoPortalHubDeviceIntegrationSection: 'デバイス連携',
    leoPortalHubDeviceIntegrationLink: '公開ドキュメント・ツール（新しいタブ）',
    leoPortalHubRuntimeModuleLink: 'Device Cloud ランタイム AAR（新しいタブ）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（エンジニア）',
    leoPortalHubSdkEngineerLabOpen: '統合テスト台（トラック1+2、新しいタブ）',
    leoPortalHubSdkPublicTrack1: 'トラック1 公開ページ',
    leoPortalHubSdkPublicTrack2: 'トラック2 公開ページ',
    leoPortalHubChatSection: 'チャット入口',
    leoPortalHubPreferences: 'マイ設定',
    leoPortalHubLogin: 'ログイン',
    leoPortalHubSectionOps: '運用コンソール',
    leoPortalHubSectionOpsDesc: 'ライブ対話・CEO／ポータル向けの主権画面。大画面での検証に適します。',
    leoPortalHubSectionPortal: 'モバイルポータル',
    leoPortalHubSectionPortalDesc: '軽量な入口。スマホやデモ向け。',
    leoPortalHubSectionChat: '対話（Leo）',
    leoPortalHubSectionChatDesc: 'Leo 対話。下段で設定・ログイン。',
    leoPortalHubSectionDeviceDesc: '公開ドキュメント、ランタイム、連携資料（いずれも新しいタブ）。',
    leoPortalHubSectionSdkDesc: '2 トラック配線・回帰・デバッグ用のエンジニア向け統合テスト台。',
    leoPortalHubCardSovereignDesc: 'バブル型チャット、Markdown、SOP ステップカード。',
    leoPortalHubCardPortalDesc: 'コンパクトな Leo ポータル。必要に応じ URL に portalToken／ceoBearer を付与。',
    leoPortalHubCardLeoDesc: '既定の Leo チャット（全球会員同一入口）。',
    leoPortalHubCardPrefDesc: 'ペルソナ、地域などの個人設定。',
    leoPortalHubCardLoginDesc: 'スタッフアカウントでログイン後、書き込み／センシティブ機能を利用。',
    leoPortalHubCardDeviceIntegrationDesc: '公開説明、トラック1 ツール、連携チェックリスト。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud ランタイム／AAR とトラック2 の入口。',
    leoPortalHubCardSdkLabDesc: 'トラック1・2 を同時に試せる統合ラボ。',
    leoPortalHubSdkFeaturedTag: 'エンジニア',
    leoPortalHubOpenNewTab: 'クリックで新しいタブ',
    leoPortalHubSdkCrossRefHint: 'トラック1／2 の公開ページは上の「デバイス連携」にある2枚のカードをご利用ください。',
    leoFloatDockTitle: 'Leo（フロート）',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '閉じる',
    leoFloatDockResizeHint: '右下をドラッグしてサイズ変更',
    leoFloatDockSwitchLabel: 'フロート Leo チャット',
    leoFloatDockSwitchHint: 'オンにすると管理画面で最前面のチャットを表示（タイトルバーをドラッグ）。Leo／Console／ポータル単体ページでは重なり防止のため非表示になります。',
    layoutThemeUseDark: 'ダークテーマに切替',
    layoutThemeUseLight: 'ライトテーマに切替',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：コンソール／ポータル／Leo チャットはサイドバー「Leo ナレッジ」内の',
    leoProfileWorkbenchLeoMovedSuffix: 'へ移動しました。',
    equipmentCategory: '機器カテゴリ',
    equipmentCategoryEdit: '機器カテゴリ（編集）',
    equipmentCategoryDel: '機器カテゴリ（削除）',
    equipmentTypePermAdd: '機器種別（一覧／追加）',
    equipmentTypePermEdit: '機器種別（編集）',
    deviceSimulatorConsole: 'シミュレーター・コンソール',
    leoDeviceOpsRolePolicy: 'コマンド権限マトリクス',
    leoDeviceOpsSemanticTraining: '意味訓練ワークベンチ',
    leoTurnRoutingTrainingHub: 'T0 入口ルーティング訓練台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 棚卸し',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS ワークベンチ',
    leoDeviceOpsReviewInbox: 'B線レビュー受信箱',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B線デイリーハブ',
    productCenter: "商品管理",
    productCenterFolderOther: 'その他製品',
    dataCenter: "データ本部",
    maintenance: "保守管理",
    filesCenter: 'ファイル管理',
    menuSetting: 'メニュー設定',
    organization: '組織管理',
    loginAccount: '垢リスト', // "账号"翻译为"アカウント"(Account)太长，为保长度用了"垢"(俗语)或"ID"，此处用"垢リスト"或"ID一覧"更短，这里选比较通用的"ID一覧"
    authorization: '権限管理',
    merchants: '加盟店一覧',
    deviceList: '機器一覧',
    deviceAutoServiceGroup: 'アフターサービス・メンテナンス',
    supportTicketGroup: 'サポート',
    supportTicketCreate: 'チケット作成',
    supportTicketMine: 'マイチケット',
    supportTicketWorkbench: 'サポート工作台',
    supportPlaybook: '標準Q&A',
    deviceServiceWorkbench: 'アフターサービス作業台',
    deviceServiceMyAssignments: '担当修理タスク',
    deviceServiceAssignees: '修理担当者',
    deviceServiceMaintenance: 'メンテナンス計画',
    deviceServiceFaultPolicy: '故障ポリシー',
    deviceServiceEnterprisePolicy: '企業ポリシー',
    deviceServiceMobile: 'モバイルタスク',
    deviceServiceBills: '修理請求',
    storeMaterialStock: '在庫概要',
    storeMaterialOrders: '発注',
    storeMaterialConsumable: '消耗品 BOM',
    storeMaterialMq: 'MQ 設定',
    storeMaterialInvoice: '請求書',
    storeMaterialBarcodeAlias: 'バーコード対応',
    storeMaterialCount: '在庫棚卸',
    storeMaterialBomWizard: 'BOMウィザード',
    storeMaterialAnalytics: '物料使用レポート',
    channelCategory: 'レーン種別',
    productCategory: '商品種別',
    optionCategory: '規格種別',
    optionList: '規格一覧',
    storeAccount: '店舗ＩＤ',
    stores: '店舗管理',
    modelName: '機器名/型番',
    category: '原料種別',
    configDistribute: 'レーン送信',
    devicesChannels: '機器レーン',
    productsList5: '商品一覧5',
    produceFivePos: '商品5店舗カスタム',
    posCenter: 'POSセンター',
    menuDistribute: 'メニュー送信',
    storeMenu: '店舗メニュー',
    merchantsData: '店舗統計',
    devicsData: '機器統計',
    productionData: '製造データ',
    maintanenceData: '保守データ',
    devicesWorkingData: '稼働データ',
    afterSalesReminder: '保守通知',
    maintenanceTips: '点検通知',
    fileUpgrade: '更新配信',
    dataDowloan: 'データＤＬ',
    materialList: '原料一覧',
    accessoriesCategory: '軽食種別',
    accessoriesList: '軽食一覧',
    businessCenter: '業務本部',
    afterSalesServiceGroup: 'アフターサービス',
    storeMaterialGroup: '在庫管理',
    appsBanner: 'Appバナー',
    advertisement: '広告一覧',
    advertBind: '広告紐付',
    advertDistribute: '広告配信',
    membersCenter: '会員一覧',
    orderCenter: '注文一覧',
    packBag: '持帰り袋',
    appsCenter: 'アプリ管理',
    productsList2: '商品一覧2',
    XTSeriesData: '調合機データ',
    productionData: '商品データ',
    materialDate: '原料データ',
    qualityData: '単杯データ',
    alertsLog: '故障ログ',
    cleaningLog: '洗浄記録',
    coffeeData: '珈琲機データ',
    coffeeSumData: '品質データ',
    taxCenter: '税務本部',
    taxManagement: '税務管理',
    taxAllocation: '税務設定',
    dataOfTeaExtractorMachine: '抽出機データ',
    teaMachineMaterial: '物料ロス',
    teaEarlyBrewWork: '多機連携',
    ecosystemMallGroup: 'エコシステムモール',
    ecosystemMallTopology: '店舗トポロジ',
    ecosystemMallCatalog: '商品と章',
    ecosystemMallSynergyEdges: '連携エッジ承認',
    ecosystemMallIntents: '意向／相談チケット',
    ecosystemMallVendors: 'ベンダーと担当者',
    ecosystemMallMediaBilling: 'メディアAI／課金',
    ecosystemMallProductSpecs: '製品仕様／不足',
    ecosystemMallLines: '生産ライン',
    ecosystemMallSearch: '検索・推薦',
    teaSingleCupParams: '単杯パラメータ',
    dataOfBlendExtractorMachine: '氷沙機データ',
    dataOfMilkExtractorMachine: '乳泡機データ',
    beverageOutputData: '提供データ',
    singleCupData: '単杯データ',
    faultLog: '故障ログ',
    deliveryPlatform: '宅配アプリ',
    uber: 'Uber',
    otherProducts: '他社製品',
    listOfTeaExtractsProducts: '萃茶機製品',
    machineDebug: '機器デバッグ',
    deviceRdGroup: 'デバイス開発',
    presetCommand: '設定指令',
    commandConfiguration: '指令設定',
    operationAndMaintenanceServices: '保守サービス',
    productionList: '商品一覧',
    smallMaterial: '小原料表',
    takeoutProducts: '宅配商品',
    pointRule: 'ポイント規定',
    couponManagement: "クーポン管理",
    couponList: "クーポン一覧",
    additionalProducts: '追加商品',
    type: '製品タイプ',
    taxAllocation: '税務設定',
    produce: '製品リスト',
    produceList4: '商品一覧4',
    smoothieMakerProduct: '氷沙機商品',
    machineMenu: '機器メニュー',
    systemLog: "システムログ",
    add: '新規',
    edit: '編集',
    delete: '削除',
    search: '検索',
    reset: 'リセット',
    detail: '詳細',
    batchImport: '一括取込',
    oneClickCopy: '一括複製',
    resetPwd: 'PWリセット',
    machineList: '機器一覧',
    export: '出力',
    log: 'ログ',
    bindStore: '店舗紐付',
    bindMachine: '機器紐付',
    codeRule: '番付ルール',
    batchDelete: '一括削除',
    region: 'エリア'

  },
  acoount: {
    name: '名称',
    enterpriseName: '企業名',
    account: 'ＩＤ',
    password: 'ＰＷ',
    confirmPassword: '確認ＰＷ',
    roleTitle: '役職',
    roleName: '役割名',
    phone: '携帯番号',
    email: 'メール',
    idNumber: '証件番号',
    workAddress: '勤務地',
    status: '状態',
    onDuty: '勤務中',
    leaveDuty: '離席中',
    takeVacationrm: '休暇中',
    disable: '無効',
    profilePicture: '肖像',
    confirmPasswordCannotBeEmpty: '確認PW未入力',
    inconsistentPasswordInput: 'PW不一致',
    emailFormatError: 'メアド形式誤り',
    phoneNumberFormatError: '番号形式誤り',
    notes: '備考',
    empower: '権限付与',
    contactInformation: '連絡先',
    userOrganizationType: '組織タイプ',
    userOrganizationName: '組織名称',
    describe: '記述',
    available: '有効',
    deactivate: '停止',

  },
  merchant: {
    account: 'ログインID',
    password: 'パスワード',
    store: '店舗',
    status: '状態',
    available: '正常',
    deactivate: '停止',
    merchantName: '加盟店名',
    cooperationType: '加盟店タイプ',
    selectCooperationTypeFirst: '先に加盟店タイプを選択',
    noUserOrganizationForType: 'このタイプのユーザー組織がありません。「ユーザー組織」で設定してください',
    enterpriseSegment: '業務区分',
    segmentDistributor: 'ディストリビューター',
    segmentShop: '店舗/加盟店',
    segmentHome: '家庭用企業',
    businessLicense: '営業許可証',
    frontIDCard: '身分証(表)',
    backIDCard: '身分証(裏)',
    head: '責任者',
    Telephone: '連絡電話',
    userOrganization: 'ユーザー組織',
    businessAddress: '登録住所',
    trade: '営業',
    closeBusiness: '休業',
    superior: '上級',
    supervisorSubordinateRelation: '上下関係',
    clickView: '詳細表示',
    business: '事業者',
    country: '国家',
    address: '住所',
    shopNames: '店舗名称',
    storeType: '店舗タイプ',
    selfService: 'セルフ',
    askFor: '自取', // "自取"在日本通常叫"テイクアウト"或"持帰り"，为了长度这里用"受取"或保留"自取"(如果是特定术语)
    SelfPickupTakeoutShop: '自取＋宅配店',
    selfServicePickUpTakeout: 'セルフ＋自取＋宅配',
    businessHours: '営業時間',
    closingTime: '閉店時間',
    operatingCycle: '営業周期',
    Monday: '月曜',
    Tuesday: '火曜',
    Wednesday: '水曜',
    Thursday: '木曜',
    Friday: '金曜',
    Saturday: '土曜',
    Sunday: '日曜',
    picture: '画像',
    vatNumber: 'VAT番号',
    kvtCompanyRegistrationNumber: 'KVK登録番号',
    invoiceUnifiedNumbering: '領収書統一番号',
    invoiceAccountNumber: '領収書口座',
    POSAPIKey: 'POS API Key',
    POSAccount: 'POS Account',
    APPAPIKey: 'APP API Key',
    APPAccount: 'APP Account',
    APPClientKey: 'APP Client Key',
    region: 'エリア'

  },
  device: {
    deviceType: '機器タイプ',
    totalDevice: '機器総数',
    passConfigName: "名称",
    offLineDevice: 'オフライン機',
    materialShortageDevice: '原料不足機',
    alertingDevice: '警報中機器',
    lockDevice: 'ロック機器',
    maintenanceDevice: '要保守機器',
    businessInformation: '業務資料',
    deviceId: '機器ID',
    deviceModel: '型番',
    dealer: "小売業者",
    deviceImie: '機器IMEI',
    appVersion: 'アプリ版',
    equipmentSerialNumber: '製造番号',
    posNumber: '端末番号',
    store: '店舗',
    location: '設置場所',
    none: '無し',
    log: "ログ",
    fault: "故障",
    normal: "正常",
    offline: "切断",
    onLine: "接続",
    isFault: "故障有無",
    type: "タイプ",
    fullyAutomatic: "全自動",
    semiAutomatic: "半自動",
    availableMerchants: "利用可能店",
    faultStatistics: "故障統計",
    basicMaintenance: "基礎保守",
    deepMaintenance: "深度保守",
    onLineDevice: '接続機器',
    equipmentOnlineStatus: "接続状態:",
    brandName: "ブランド名:",
    telephone: "電話:",
    equipmentModelName: "型番/名称:",
    dateOfManufacture: "製造日付:",
    usageDate: "使用日付:",
    menu: "メニュー",
    productName: "商品名",
    channelConfiguration: "レーン設定",
    channelNumber: "レーンNo",
    material: "原料",
    shelfLife: "賞味期限",
    alarmListForTheDay: "警報一覧(当日)",
    content: "内容",
    time: "時間",
    key: "ボタン",
    frequency: "回数",
    remoteOperation: "遠隔操作",
    menuStatus: "メニュー状態",
    updated: "更新済",
    notUpdated: "未更新",
    success: "成功",
    lock: "ロック",
    unlock: "解除",
    startup: "起動",
    shutdown: "終了",
    restart: "再起動",
    param: "変数",
    factoryParam: '出荷変数',
    moduleParam: 'モジュール',
    paramBaselineOpen: 'パラメータ',
    paramBaselineTitle: 'パラメータ基準（Leo）',
    paramBaselineHint: 'JSON パス（例: config.stirTime）をデバイス設定に合わせてください。',
    paramBaselineAddRow: '行を追加',
    paramBaselineSave: '保存',
    paramBaselineRefresh: '再読込',
    paramKey: 'キー',
    paramKeyPh: '例: config.stirTime',
    paramDisplayName: '表示名',
    standardValue: '基準値',
    lowerLimit: '下限',
    upperLimit: '上限',
    unit: '単位',
    paramRemark: '備考',
    paramBaselineNoProfile: 'この型番に読める L1 Profile（または PUBLISHED）がありません。Profile 管理で作成・公開してください。',
    paramBaselineProfileSource: 'デフォルト元: {name} · published {version}',
    paramBaselineApplyPublished: '最新 published から反映',
    paramBaselineApplyConfirm: '最新 published の JSON をマージします（同一キーは上書き）。よろしいですか？',
    paramBaselineApplyDone: 'published の提案を反映しました（保存してください）',
    paramBaselineTypeUnionTitle: '同一機種カテゴリ · published パス集合（参考）',
    paramBaselineTypeUnionMissing: 'Profile が無い型番 ID',

  },
  produce: {
    name: '名称',
    price: '価格',
    uberPrice: 'Uber単価',
    matterType: '原料タイプ',
    normType: '規格タイプ',
    matter: '原料',
    min: '最小値',
    max: '最大値',
    shelfLife: '賞味期限',
    unit: '単位',
    hour: '時間',
    step1: '商品資料',
    step2: '商品原料',
    step3: '商品処方',
    step4: '処方組合',
    step5: '商品小料',
    produceName: '商品名称',
    produceCode: '商品コード',
    produceType: '商品タイプ',
    showSnacks: '軽食表示',
    yes: 'はい',
    no: 'いいえ',
    describe: '記述',
    order: '順序',
    value: '値',
    unit: '単位',
    norm: '規格',
    select: '選択',
    step: '手順',
    matterSequence: '原料順序',
    action: '操作',
    freeSnacks: '無料追加',
    feeBasedMaterials: '有料追加',
    nextStep: '次へ',
    back: '戻る',
    save: '保存',
    saveUpdate: '更新保存',
    productList: '商品メニュー',
    selectProduct: '商品選択',
    menuSort: '順位',
    produceImport: '商品取込',
    bind: '紐付',
    bindMachien: '機器紐付',
    smallMatterType: '小料タイプ',
    listing: '公開',
    isSales: '注文可',
    productListName: "商品メニュー名入力",
    Text1: '商品名称入力',
    Text2: '加盟店',
    Text3: '原料',
    Text4: '小料',
    Text5: '飲料',
    Text6: '軽食',
    Text7: '新規処方',
    Text8: '更新',
    Text9: '商品コード重複',
    Text10: '情報を完備下さい',
    Text11: '茶類',
    Text12: '第一段階',
    Text13: '第二段階',
    Text14: '第三段階',
    Text15: '出す',
    Text16: '出さない',
    Text17: '範囲:',
    Text18: '茶葉量:',
    Text19: '数字のみ入力可',
    Text20: '氷の量:',
    Text21: '同一段の攪拌時間は萃茶/抽出時間を超えられません（上限 {max}）',
    Text22: '萃茶/抽出時間は現在の攪拌時間より小さくできません（{min}）',
    Text23: 'レシピ「{name}」：攪拌時間が萃茶/抽出上限（{max}）を超えています。保存前に調整してください',
    codeRule: '編集規則',
    prefix: '接頭辞',
    suffix: '接尾辞',
    review: 'プレビュー',
    codeRuleDescribe: 'レジ印字用コードの形式となります',

  },
  business: {
    name: '名称',
    type: 'タイプ',
    homepage: 'ホーム',
    advertisingList: '広告一覧',
    pictureOrVideo: '画像/動画',
    addProductAdvertisements: '商品広告追加',
    AddImagesOrvideos: '画像/動画追加',
    userName: 'ユーザー名',
    email: 'メール',
    sex: '性別',
    birthday: '誕生日',
    phone: '携帯番号',
    walletBalance: '財布残高',
    integral: 'ポイント',
    orderNo: '注文番号',
    pickupCode: '受取コード',
    store: '店舗',
    amount: '注文金額',
    payAmount: '支払金額',
    receiptsPrice: '受取金額',
    discount: '値引き',
    orderStatus: '注文状態',
    toBePaid: '未払',
    paid: '済',
    processing: '処理中',
    completed: '完了',
    orderCancellation: '注文取消',
    orderRejection: '注文拒否',
    paymentMethod: '支払方式',
    wallet: '財布',
    cash: '現金',
    pos: 'カード機',
    thirdParty: '第三者',
    otherPay: 'その他',
    produce: '商品',
    unitPrice: '単価',
    number: '数量',
    parameter: '変数',
    totalTaxAmount: '総税額',
    taxName: '税名',
    taxAmount: '税額',
    taxRate: '税率',
    orderType: '注文タイプ',
    pack: '持帰り',
    dineIn: '店内',

  },
  file: {
    name: '名称',
    version: 'Ver',
    keyword: '識別',
    file: 'ファイル',
    upload: 'アップ',
    remark: '備考'

  },
  coupon: {
    Text1: '名称',
    Text2: '割引金額',
    Text3: '消費ポイント',
    Text4: '状態',
    Text5: '詳細',
    Text6: '利用可',
    Text7: '利用不可',
    Text8: '有効日数'

  },
  pass: {
    name: '名称',
    pass: 'レーン',
    passNumber: 'レーンNo',
    preDischargeTime: '予備排出時間',
    addPass: '新規レーン',
    bindPass: 'レーン紐付',
    passConfigName: 'レーン設定名'

  },
  operation: {
    business_data: "業務データダッシュボード",
    orderAmount: "注文金額",
    orderQuantity: "注文数量",
    actualAmountReceived: "実収金額",
    top_10_beverage_rankings: "飲品ランクTop10",
    sales_revenue: "売上高",
    order_quantity: "注文数",
    payment_method: "支払方式",
    real_time_orders_on_the_hour: "リアルタイム注文",
  },
  dataCenter: {
    Text1: "内容",
    Text2: "データ",
    Text3: "販売量/杯",
    Text4: "売上額/円",
    Text5: "消費原料/g",
    Text6: "月",
    Text7: "日",
    Text8: "時",
    Text9: "図表",
    Text10: "単杯消費原料",
    Text11: "順位",
    Text12: "商品消費原料",
    Text13: "機器消費原料",
    Text14: "比率",
    Text15: "順位",
    Text16: "販売量",
    Text17: "売上額",
    Text18: "時間/S",
    Text19: "商品販売量",
    Text20: "商品売上額",
    Text21: "機器販売量",
    Text22: "機器売上額",
    Text23: "総杯量",
    Text24: "総処方量/克",
    Text25: "実総処方量/克",
    Text26: "失敗量/杯",
    Text27: "失敗率/%",
    Text28: "誤差率/%",
    Text29: "商品名称",
    Text30: "制作方式",
    Text31: "QR",
    Text32: "商品",
    Text33: "手動",
    Text34: "注文番号",
    Text35: "店舗",
    Text36: "単価",
    Text37: "処方総量",
    Text38: "実出杯量",
    Text39: "出杯時間",
    Text40: "誤差(%)",
    Text41: "失敗",
    Text42: "正常",
    Text43: "制作完了",
    Text44: "制作失敗",
    Text45: "完了時間",
    Text46: "モード",
    Text47: "レーン",
    Text48: "状態",
    Text49: "未完了",
    Text50: "完了",
    Text51: "商品名称",
    Text52: "杯数",
    Text53: "総価",
    Text54: "注文統計",
    Text55: "注文一覧",
    Text56: "注文金額",
    Text57: "注文数量",
    Text58: "実収金額",
    Text59: "商品金額",
    Text60: "茶葉量",
    Text61: "出水量",
    Text62: "販売量/樽",
    Text63: "樽",
    Text64: "酸味/抽出不足",
    Text65: "均衡/抽出適正",
    Text66: "苦味/抽出過多",
    Text67: "苦/濃度低",
    Text68: "適正",
    Text69: "強/濃度高",
    Text70: "抽出時間",
    Text71: "水粉比",
    strongBalance: "強バランス",
    weakBalance: "弱バランス",
    mediumAcid: "中酸味",
    strongAcid: "強酸味",
    goldenCup: "金賞(適正)",
    weakAcid: "弱酸味",
    bitter: "苦味",
    strongBitter: "強苦味",
    weakBitter: "弱苦味",
    extractionTime: "抽出時間",
    Text72: "動的校正",
  },
  taxation: {
    Text1: "税名",
    Text2: "税率",
    Text3: "基数",
    Text4: "備考",
    Text5: "国家",
    Text6: "タイプ",
    Text7: "店内",
    Text8: "持帰り",
    Text9: "商品タイプ",
    Text10: "税種",
    Text11: "宅配アプリ",
  },
  uber: {
    Text1: "Uber店舗",
    Text2: "PF店舗",
    Text3: "メニュー状態",
    Text4: "店舗状態",
    Text5: "紐付済",
    Text6: "未紐付",
    Text7: "同期"

  },

  login: {
    title: 'システム登录',
    logIn: 'ログイン',
    username: 'ID',
    password: 'PW',
    readAndAgree: '同意済み',
    pleaseCheckThePrivacyAgreement: '規約をチェックして下さい',
    termTip: '<<個人情報規約>>',
    Text1: 'IDを入力',
    Text2: 'IDを入力'


  },
  navbar: {
    logOut: 'ログアウト',
    dashboard: 'ホーム',
    github: 'プロジェクト',
    screenfull: '全画面',
    theme: 'スキン',
    size: 'レイアウト'
  },
  tagsView: {
    refresh: '更新',
    close: '閉じる',
    closeOthers: '他を閉じる',
    closeAll: '全閉じる'
  },
  common: {
    tower: '台',
    yuan: '円',
    cup: '杯',
    place: '位',
    individual: '個',
    language: '言語',
    success: '成功',
    fail: '失敗',
    createTime: '作成日時',
    all: '全部',
    common: '全部',
    sureDel: '削除確認',
    tip: '提示',
    status: '状態',
    bing: '紐付',
    pleaseSelectDevice: '機器を選択',
    pleaseSelectMenu: 'メニュー選択',
    pleaseSelectModel: '型番を選択',
    pleaseSelect: '選択して下さい',
    code: 'コード',
    entering_the_platform: 'PFへ',
    date: "日付",
    address_fail: "住所不正",
    back: '戻る',
    pleaseEnter: '入力して下さい',
    uploadImageBtn: '画像アップロード',
    uploadImageBtnTip: 'JPG/PNGのみ対応（10M以内）',
    uploadVideoBtn: '動画アップロード',
    uploadVideoBtnTip: 'mp4/MP4のみ対応（50M以内）',
    videoPlayTip: ' このブラウザは動画非対応です',
    menuVersion: "メニューVer"

  },
  table: {
    search: '検索',
    detail: '詳細',
    actions: '操作',
    edit: '編集',
    publish: '公開',
    delete: '削除',
    cancel: '取消',
    confirm: '確定',
    add: '新規',
    copy: '複製',
    produceCodeRule: '番付ルール',
    batchDeletion: '一括削除',
    batchImport: '一括取込',
    batchCopy: '一括複製',
    export: 'データ出力',
    exportAll: '全件出力',
    import: '取込',
    templateDownload: '雛形ＤＬ',
    dragAndDropUpload: 'ここにファイルをドロップ',
    picture: '画像',
    resetPwd: 'ＰＷリセット',
    more: 'その他'
  },
  coffeeData: {
    Text1: "浸漬流量",
    Text2: "浸漬時間",
    Text3: "抽出流量",
    Text4: "抽出圧力",
    Text5: "抽出温度",
    Text6: "注文タイプ",
    Text7: "状態",
    Text8: "出杯時間",
    Text9: "粉量",
    Text10: "機器コード",
    Text11: "商品名称",
    Text12: "コーヒー液",
    Text13: "タンプ圧",
    Text14: "パック厚",
    Text15: "抽出流速",
    Text16: "抽出室位置",
    Text17: "挽き目1",
    Text18: "挽き目2",

  }
}


// WEBPACK FOOTER //
// ./src/lang/ja.js